export const BRAND = {
  name: "Luigi's Hydro Clean",
  legal: "Luigi's Hydro Clean, LLC",
  tagline: "Making South Florida Shine!",
  phone: "954-645-2753",
  phoneHref: "tel:+19546452753",
  email: "support@luigishyrdowash.com",
  area: "Broward County & South Florida",
  hours: "Monday – Saturday: 8:00 AM – 6:00 PM | Sunday: Closed",
  logo: "https://customer-assets.emergentagent.com/job_04b53e63-436c-479c-a5e1-e2ae7da8f420/artifacts/zkp80hmq_Luigi%27s%20Hydro%20Care.png",
};

export const IMAGES = {
  heroAction: "https://images.unsplash.com/photo-1718152521364-b9655b8a7926?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  driveway: "https://images.unsplash.com/photo-1781637202423-33ec5b47e52e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  neighborhood: "https://images.unsplash.com/photo-1605146768851-eda79da39897?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  commercial: "https://images.unsplash.com/photo-1768612351434-9dc20933f7cc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  aboutWorker: "https://images.unsplash.com/photo-1581883579507-019c44b711cb?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  floridaHouse: "https://images.unsplash.com/photo-1613850011958-cfb3e7364058?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

export const RESIDENTIAL_SERVICES = [
  {
    icon: "Car",
    title: "Driveway Cleaning",
    desc: "Stubborn oil stains, tire marks, and baked-on dirt disappear. We restore your concrete, pavers, or asphalt to pristine condition.",
  },
  {
    icon: "Footprints",
    title: "Sidewalk Cleaning",
    desc: "Enhance your home's curb appeal and keep walking paths safe, slip-free, and clear of dark mold and slime.",
  },
  {
    icon: "Sofa",
    title: "Patio & Deck Cleaning",
    desc: "Get your outdoor living spaces ready for entertaining. We gently yet effectively clean brick, concrete, tile, and wood patios.",
  },
  {
    icon: "Home",
    title: "Exterior House Cleaning",
    desc: "Remove dirt, cobwebs, mold, and algae from your siding, stucco, or brickwork using safe low-pressure soft-washing techniques.",
  },
];

export const COMMERCIAL_SERVICES = [
  {
    icon: "Building2",
    title: "Building Washing",
    desc: "Keep your storefront, corporate office, or facility looking professional. A clean exterior builds immediate trust with your customers.",
  },
  {
    icon: "Building",
    title: "HOA & Multi-Family Cleaning",
    desc: "Complete pressure washing for HOAs, apartment complexes, and condominiums — common areas, perimeter walls, and community walkways.",
  },
  {
    icon: "Route",
    title: "Concrete & Walkway Cleaning",
    desc: "High-traffic storefronts, plazas, and sidewalks accumulate grime and chewing gum. We blast it away to keep your paths inviting.",
  },
  {
    icon: "Truck",
    title: "Loading Docks & Dumpster Pads",
    desc: "Eliminate greasy buildup, foul odors, and safety hazards. Our heavy-duty pressure washing sanitizes and degreases your toughest zones.",
  },
];

export const WHY_CHOOSE = [
  {
    icon: "MapPin",
    title: "Local Experts",
    desc: "Proudly keeping South Florida clean, safe, and beautiful — one property at a time.",
  },
  {
    icon: "Leaf",
    title: "Eco-Friendly & Safe",
    desc: "Advanced equipment and cleaning agents that protect your property and landscaping.",
  },
  {
    icon: "ShieldCheck",
    title: "Guaranteed Satisfaction",
    desc: "We don't leave until your property looks brand new. That's our promise to you.",
  },
];

export const SERVICE_OPTIONS = [
  "Residential: Driveway / Sidewalk",
  "Residential: Patio / Deck",
  "Residential: Full Exterior House Wash",
  "Commercial: Building / Storefront",
  "Commercial: Concrete & Walkways",
  "Commercial: Loading Docks / Dumpster Pads",
  "Commercial: HOA / Community Areas",
];
